import LoadingOvalIcon from "./loadingOval.icon";

export default function LoadingOvalCenterIcon() {
  return (
    <div className="flex justify-center py-20">
      <LoadingOvalIcon className="w-14 h-14" />
    </div>
  );
}
